import { Component, Input, OnDestroy } from '@angular/core';
import { ReportsService } from '../../core/reports.service';
import { SaveReportAsCsvService } from '../../core/save-report-as-csv.service';
import { SaveReportAsPdfService } from '../../core/save-report-as-pdf.service';
import { ReportsStore } from '../../state/reports-store';
import { saveAs } from 'file-saver';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-report-export-to',
  templateUrl: './report-export-to.component.html',
  styleUrls: ['./report-export-to.component.scss'],
})
export class ReportExportToComponent implements OnDestroy {
  @Input()
  fileToken: string;
  @Input()
  time_to: string;
  @Input()
  time_from: string;
  @Input()
  label: string;

  saveAsCSVSubscription: Subscription;
  saveAsPDFSubscription: Subscription;

  constructor(
    public reportService: ReportsService,
    public reportsStore: ReportsStore,
    private saveAsPdfService: SaveReportAsPdfService,
    private saveAsCsvService: SaveReportAsCsvService
  ) {}

  ngOnDestroy() {
    if (this.saveAsCSVSubscription) {
      this.saveAsCSVSubscription.unsubscribe();
    }
    if (this.saveAsPDFSubscription) {
      this.saveAsPDFSubscription.unsubscribe();
    }
  }

  saveAsPDF() {
    this.saveAsPDFSubscription = this.saveAsPdfService
      .saveAsPDF(this.fileToken)
      .subscribe((res: Response) => {
        const file = new Blob([(<any>res).body], {
          type: 'application/pdf;charset=utf-8',
        });
        const filename = this.getFilename(res);
        saveAs(file, filename);
      });
  }

  saveAsCSV() {
    this.saveAsCSVSubscription = this.saveAsCsvService
      .saveAsCSV(this.fileToken)
      .subscribe((res: Response) => {
        const file = new Blob([(<any>res).body], {
          type: 'application/csv;charset=utf-8',
        });
        const filename = this.getFilename(res);
        saveAs(file, filename);
      });
  }

  private getFilename(res: Response) {
    let filename = res.headers
      .get('Content-Disposition')
      .toString()
      .split(';')[1]
      .trim()
      .split('=')[1];
    decodeURIComponent(filename);
    filename = filename.replace(/'/g, '');
    filename = filename.replace(/"/g, '');
    filename =
      filename.split('__').slice(0, -1).join('__') +
      '.' +
      filename.split('__').slice(-1)[0].split('.')[1];
    return filename;
  }
}
